import { createColumnHelper } from "@tanstack/react-table";
import TanStackTableCheckBox from "./TanStackTableCheckBox";
import { format } from "date-fns";
import { calculateUserMedicalStatus } from "../Users/calculateUserMedicalStatus";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const columnHelper = createColumnHelper();

export const commonUserListColumns = (userListData, options = {}) => {
  return [
    columnHelper.accessor("SL.", {
      id: "multiple_select",
      header: ({ table }) => (
        <div>
          <TanStackTableCheckBox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: table.getToggleAllRowsSelectedHandler(),
            }}
          />
        </div>
      ),
      cell: ({ row }) => {
        return (
          <div>
            <TanStackTableCheckBox
              {...{
                checked: row.getIsSelected(),
                disabled: !row.getCanSelect(),
                indeterminate: row.getIsSomeSelected(),
                onChange: row.getToggleSelectedHandler(),
              }}
            />
          </div>
        );
      },
    }),
    columnHelper.accessor("SL.2", {
      id: "SL.2",
      header: () => (
        <div className="text-center">
          <span className="text-center px-2">SL</span>
        </div>
      ),
      cell: (info) => {
        const reversedSerialNumber = userListData.length - info?.row?.index;
        return (
          <div className="text-left fw-bold">
            <span className="text-center">{reversedSerialNumber}</span>
          </div>
        );
      },
    }),

    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: () => <span className="d-flex justify-content-center">Date</span>,
      cell: (info, index) => {
        const formattedDate = format(
          new Date(info?.row?.original?.createdAt),
          "dd-MM-yyyy",
        );
        return (
          <div className="d-flex justify-content-start">{formattedDate}</div>
        );
      },
    }),
    columnHelper.accessor("registration_no", {
      id: "registration_no",
      header: () => (
        <span className="text-center d-flex justify-content-center">
          Reg. No
        </span>
      ),
      cell: (info) => {
        return (
          <div className="d-flex justify-content-start">
            {info?.row?.original?.reg_prefix || ""}
            {info.getValue()}
          </div>
        );
      },
    }),

    ...(options?.fromMedicalReports
      ? [
          columnHelper.accessor("unique_id", {
            header: () => (
              <span className="text-center d-flex justify-content-center">
                Unique ID
              </span>
            ),
            cell: (info) => {
              return (
                <div className="d-flex justify-content-start">
                  {/* {info?.row?.original?.unique_id || ""} */}
                  {info.getValue()}
                </div>
              );
            },
          }),
        ]
      : []),

    columnHelper.accessor("f_name", {
      id: "name",
      header: () => (
        <span className="text-center d-flex justify-content-center">
          Passenger Name
        </span>
      ),
      cell: (info) => {
        return (
          <div className="d-flex justify-content-start">{info.getValue()}</div>
        );
      },
    }),
    columnHelper.accessor("passport_no", {
      id: "passport_no",
      header: () => (
        <span className="text-center d-flex justify-content-center">
          Passport No
        </span>
      ),
      cell: (info) => {
        return (
          <div className="d-flex justify-content-start">{info.getValue()}</div>
        );
      },
    }),
    columnHelper.accessor("userDetail.introducer_user.f_name", {
      id: "agency",
      header: () => (
        <span className="text-center d-flex justify-content-center">
          Agency
        </span>
      ),
      cell: (info) => {
        const value1 = info.getValue();
        const representative_Mob =
          info?.row?.original?.userDetail?.introducer_user?.user_users_maps[0]?.representative_user_map?.mobile?.slice(
            -2,
          );

        return (
          <div>
            {representative_Mob ? (
              <span className="text-center d-flex justify-content-start">
                {value1} - ({representative_Mob})
              </span>
            ) : (
              <span className="text-center d-flex justify-content-start">
                {value1}
              </span>
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor("userDetail.country.shortname", {
      header: () => (
        <span className="text-center d-flex justify-content-center">
          Country
        </span>
      ),
      cell: (info) => {
        return (
          <div className="d-flex justify-content-start">{info.getValue()}</div>
        );
      },
    }),
    columnHelper.accessor("userDetail.package.name", {
      id: "package",
      header: () => (
        <span className="text-center d-flex justify-content-center">
          Package
        </span>
      ),
      cell: (info) => {
        const userTest = info?.row?.original?.userTest || [];
        // console.log("Investigation Code:", userTest);
        const userTestInvestigation = userTest
          ?.map((test) => test?.investigation?.code)
          .join(", ");
        // console.log('Investigation Code:', userTestInvestigation);
        //
        const reInv = (info?.row?.original?.reInvestigationData || [])
          .map((inv) => inv.code)
          .join(", ");
        if (info?.row?.original?.reInvstIds) {
          return (
            <div className="d-flex justify-content-start">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{reInv}</Tooltip>}
              >
                <span>
                  {reInv?.substring(0, 15) +
                    `${reInv?.length > 15 ? "..." : ""}`}
                </span>
              </OverlayTrigger>
            </div>
          );
        }

        return (
          <div className="d-flex justify-content-start">
            {info?.row?.original?.role_id === 5 ? (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{userTestInvestigation}</Tooltip>}
              >
                <span>
                  {options?.individualPackageFullName
                    ? userTestInvestigation
                    : userTestInvestigation?.substring(0, 15) +
                      `${userTestInvestigation?.length > 15 ? "..." : ""}`}
                </span>
              </OverlayTrigger>
            ) : (
              info.getValue()
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor("role.name", {
      id: "type",
      header: () => (
        <span className="text-center d-flex justify-content-center">Type</span>
      ),
      cell: (info) => {
        return (
          <div className="d-flex justify-content-start">
            {info?.row?.original?.role_id === 5
              ? "Individual Test"
              : info?.row?.original?.reInvstIds
                ? "Reinvestigation"
                : info.getValue()}
          </div>
        );
      },
    }),

    columnHelper.accessor("created_by", {
      id: "created_by",
      header: () => (
        <span className="text-center d-flex justify-content-center">
          Created By
        </span>
      ),
      cell: (info) => {
        return (
          <div className="d-flex justify-content-start">
            {info?.row?.original?.created_by}
          </div>
        );
      },
    }),

    columnHelper.accessor("amount", {
      id: "amount",
      header: () => (
        <span className="text-center d-flex justify-content-center">
          Amount
        </span>
      ),
      cell: (info) => {
        return (
          <div className="d-flex justify-content-start">
            {info?.row?.original?.userDetail?.user_payment?.amount || ""}
          </div>
        );
      },
    }),
    columnHelper.accessor("status", {
      id: "status",
      header: () => (
        <span className="text-center d-flex justify-content-center">
          Status
        </span>
      ),
      cell: (info) => {
        const { isDone, status } = calculateUserMedicalStatus(
          info?.row?.original,
        );

        let content;

        // there was done
        if (isDone && status === 2) {
          content = "FIT";
        } else if (isDone && status === 3) {
          content = "UNFIT";
        } else if (isDone && status === 4) {
          content = "HELD-UP";
        } else {
          content = "PROCESSING";
        }

        return <div className="d-flex justify-content-start">{content}</div>;
      },
    }),
  ];
};

